//Event archive
(function($) {
    "use strict";

    const $section_news_archive = $('.section-news-archive');

    if ($section_news_archive.length === 0) return;

    //manual ajax load-more
    $section_news_archive.on('click', 'a.load-more', function(e){
        //block the click action
        e.preventDefault();
        //remove the load-more button
        $(this).remove();
        //ajax get events
        $.ajax(
            $(this).attr('href'),
            {
                success: function(data) {
                    //find all events in response and append them to the results
                    $('.sf_results_row > *', data).appendTo($('.sf_results_row'));

                    //copy over the new load-more link, if it exists
                    $('.sf_results_pagination', data).appendTo($('.sf_results'));
                },
            }
        )
    });

})(jQuery);

//Search and filter
(function(){
    let newsArchive = document.querySelector('.section-news-archive');
    if (!newsArchive) return;
    let postCountContainer = newsArchive.querySelector('.post-count');
    let postCount = document.querySelector('#post_count');
    let formUL = newsArchive.querySelector('.sf_form form ul');
    let li = document.createElement('li');
    li.classList.add('post-counter');
    li.appendChild(postCountContainer);
    formUL.appendChild(li);
    let plural = document.querySelector('#post_count_plural');
    let initialCount = postCount ? parseInt(postCount.dataset.all) : 0;
    let catList = newsArchive.querySelector('.sf-field-taxonomy-news_category');
    let observer;
    if(catList){
        observer = new MutationObserver((mutationsList, observer) => {
                for(let mutation of mutationsList){
                    let active = newsArchive.querySelector('.sf-field-taxonomy-news_category .sf-option-active');
                    if(active){
                        updateCount(active);
                    }
                    else{
                        if(newsArchive.querySelector('.sf-field-search input')?.value){
                            let count = getLargestCount();
                            updateCount(null,count);
                        }
                        else{
                            updateCount(null,null);
                        }
                    }
                }
                jQuery(function($){
                    $('select').select2({
                        minimumResultsForSearch: Infinity,
                        width: ''
                    });
                });
        });
        observer.observe(catList, {childList: true});
    }
    function updateCount(active,count = null){
        if(active){
            count = active.dataset.sfCount;
        }
        if(!count&&count!==0){
            count = initialCount;
        }
        postCount.innerHTML = count;
        if(count == 1){
            plural.classList.add('hidden');
        }
        else{
            plural.classList.remove('hidden');
        }
        if(observer){
            observer.disconnect
        }
    }

    function getLargestCount(){
        let allCats = newsArchive.querySelectorAll('.sf-field-taxonomy-news_category li');
        let count = 0;
        allCats = Array.from(allCats);
        if(allCats.length == 0){
            return count;
        }
        allCats = allCats.map(cat=>parseInt(cat.dataset.sfCount));
        count = Math.max(...allCats);
        return count;
    }

    if(newsArchive.querySelector('.sf-field-search input')?.value){
        let count = getLargestCount();
        updateCount(null,count);
    }
    else{
        updateCount(document.querySelector('.sf-option-active'));
    }

    let wWidth = window.innerWidth;
    if(wWidth<1000){
        let fakeDetails = newsArchive.querySelector('.sf-field-taxonomy-news_category ul');
        let fakeSummary = newsArchive.querySelector('.sf-field-taxonomy-news_category h4');
        fakeSummary.innerHTML = 'Select category';
        fakeSummary.addEventListener('click',()=>{
            fakeDetails.classList.toggle('open');
        });
    }
})();